import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { isEqual } from 'lodash';
import { map } from 'rxjs/operators';
import { StafferSettingsStoreService } from '../../staffer-settings-store.service';

@Component({
  selector: 'pr-treatment-plan-grouped-toggle',
  templateUrl: './treatment-plan-grouped-toggle.component.html',
  styleUrls: ['./treatment-plan-grouped-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, MatTooltipModule, MatIconModule],
})
export class TreatmentPlanGroupedToggleComponent {
  private _stafferSettings = inject(StafferSettingsStoreService);
  compact = input<boolean>(true);
  colour = input<string>('!text-gray-500');
  grouped = signal<boolean>(false, { equal: isEqual });

  constructor() {
    this._stafferSettings.treatmentPlan$
      .pipe(
        map((settings) => !!settings.groupedTreatments),
        takeUntilDestroyed()
      )
      .subscribe((grouped) => this.grouped.set(grouped));
  }

  toggleTreatmentGrouping(): void {
    const toggled = !this.grouped();
    this.grouped.set(toggled);

    this._stafferSettings.updateStafferSettings({
      treatmentPlan: { groupedTreatments: toggled },
    });
  }
}
